<div class="mt-24">
  <div class="filter">
    <div class="grid grid--va-bottom">
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Наименование</label>
          <app-combobox
            [items]="filter.companies"
            (callback)="onChangeSelectedCompany($event)"
            [textKey]="'new_name'"
            [defaultText]="'Искать по наименованию'"
            [initBy]="filter.companySelected"
            [name]="'companyName'"
          ></app-combobox>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Номер договора</label>
          <input class="input-text" type="text" id="contractNumber" placeholder="Введите номер договора" [(ngModel)]="filter.companyContract" />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-field>
          <label>Код партнера</label>
          <app-combobox
            [items]="filter.codes"
            (callback)="onChangeSelectedCode($event)"
            [textKey]="'partner_code'"
            [defaultText]="'Искать по коду партнера'"
            [initBy]="filter.codeSelected"
            [name]="'codeName'"
          ></app-combobox>
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <button
              class="button"
              type="button"
              id="appApplyCompanyFilter"
              (click)="onApplyFilter()"
              [disabled]="!filter.companySelected && !filter.codeSelected && !filter.companyContract"
            >
              Применить
            </button>
          </div>
          <div class="grid__box grid__box--size-min">
            <a id="appResetCompanyFilter" class="link link--dotted-blue-dark" (click)="onResetFilter()">Сбросить</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
